import { useState, useCallback, useEffect } from 'react';
import ResizeObserver from 'resize-observer-polyfill';

/**
 * useResizeObserver can either take a target observing element or assign a ref to a node
 */
export function useResizeObserver<T extends Element>() {
  const [element, setElement] = useState<T | null>(null);
  const [dimension, setDimension] = useState({ width: 0, height: 0 });

  const ref = useCallback((node: T) => {
    setElement(node);
  }, []);

  useEffect(() => {
    if (!element) return;

    const resizeObserver = new ResizeObserver((entries) => {
      for (const entry of entries) {
        if (entry.target === element) {
          setDimension({
            width: entry.contentRect.width,
            height: entry.contentRect.height,
          });
        }
      }
    });

    resizeObserver.observe(element);

    return () => {
      resizeObserver.disconnect();
    };
  }, [element]);

  return { ref, dimension };
}
